import { Paper } from '@mui/material'
import { JSX } from 'react'

interface Props {
  modules: JSX.Element[]
}

const ModuleMenuContainer = ({ modules }: Props) => {
  return (
    <Paper
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: '332px',
        gap: '6px',
        p: '10px'
      }}
    >
      {modules}
    </Paper>
  )
}

export default ModuleMenuContainer
